// The platform (system-admin) destinations, grouped.
//
// Shared by the app bar's system-admin nav so the routes in App.js and the way
// in to them cannot drift — the same reason SETTINGS_GROUPS exists. Before
// this, the only way to reach any of these was the Quick Actions column on the
// dashboard: leaving it meant going back to the dashboard first, and two pages
// (Plans, Analytics) had a route but no link anywhere, so they were reachable
// only by typing the URL.
//
// Shape mirrors settingsMenu.js: flat items first, then groups. Four
// destinations stay flat and the rest group under two menus, which is the same
// grouping-not-shrinking trade the main bar makes (#245).
import {
  Dashboard as OverviewIcon,
  Business as BusinessIcon,
  Task as TaskIcon,
  TrendingUp as TrendingUpIcon,
  Security as SecurityIcon,
  Loyalty as PlansIcon,
  VpnKey as TokenIcon,
  AutoAwesome as AIIcon,
  Hub as McpIcon,
  Storage as StorageIcon,
  Paid as BillingIcon,
  FactCheck as UsageCheckIcon,
  SwapHoriz as SwapIcon,
  History as HistoryIcon,
  PersonAdd as SignupAttemptsIcon,
  GppMaybe as SignInAttemptsIcon,
  SystemUpdate as AppUpdatesIcon,
  Email as EmailIcon,
  Description as TemplatesIcon,
} from '@mui/icons-material';

/** Always-visible destinations, in the order an operator reaches for them. */
export const SYSTEM_ADMIN_FLAT = [
  { path: '/system-admin', label: 'Overview', icon: OverviewIcon, exact: true },
  { path: '/system-admin/subscribers', label: 'Subscribers', icon: BusinessIcon },
  { path: '/system-admin/live-tasks', label: 'Live tasks', icon: TaskIcon },
  { path: '/system-admin/analytics', label: 'Analytics', icon: TrendingUpIcon },
];

/** The rest, behind two dropdowns. */
export const SYSTEM_ADMIN_GROUPS = [
  {
    title: 'Configuration',
    items: [
      { path: '/system-admin/admins', label: 'System admins', icon: SecurityIcon },
      { path: '/system-admin/plans', label: 'Plans', icon: PlansIcon },
      { path: '/system-admin/signup-tokens', label: 'Signup tokens', icon: TokenIcon },
      { path: '/system-admin/ai-settings', label: 'AI settings', icon: AIIcon },
      { path: '/system-admin/mcp', label: 'MCP server', icon: McpIcon },
    ],
  },
  {
    title: 'Operations',
    items: [
      { path: '/system-admin/storage', label: 'Storage', icon: StorageIcon },
      { path: '/system-admin/billing', label: 'Billing', icon: BillingIcon },
      { path: '/system-admin/usage-check', label: 'Usage check', icon: UsageCheckIcon },
      { path: '/system-admin/templates', label: 'Templates', icon: TemplatesIcon },
      { path: '/system-admin/migration', label: 'SSS migration', icon: SwapIcon },
      { path: '/system-admin/signup-attempts', label: 'Signup attempts', icon: SignupAttemptsIcon },
      { path: '/system-admin/sign-in-attempts', label: 'Sign-in attempts', icon: SignInAttemptsIcon },
      { path: '/system-admin/app-updates', label: 'App updates', icon: AppUpdatesIcon },
      { path: '/system-admin/audit-log', label: 'Audit log', icon: HistoryIcon },
      { path: '/system-admin/email-log', label: 'Email log', icon: EmailIcon },
    ],
  },
];

/** Every system-admin destination, flat — for tests and coverage checks. */
export const ALL_SYSTEM_ADMIN_ITEMS = [
  ...SYSTEM_ADMIN_FLAT,
  ...SYSTEM_ADMIN_GROUPS.flatMap(g => g.items),
];
